const isMobile = () => {
  if (document.documentElement.clientWidth > 1045) {
    return false;
  } else {
    return true;
  }
};

export default isMobile;
